import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const JobType = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['job-type', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [optionStatus, setOptionStatus] = useState([])

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status")
        .then((res: any) => {
          let common_status = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          setOptionStatus(common_status)
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])


  return <FormMaster
    title={t('job_type_information')}
    tableConfig={{
      key: "id",
      apiPath: "job_type/list",
      allowDelete: {
        visible: true,
        key: "job_type_id",
        apiPath: "job_type/delete",
        paramType: 'param'
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'job_type_code',
          caption: t('job_type_code'),
          allowFiltering: true
        },
        {
          dataField: 'job_type_name',
          caption: t('job_type_name'),
          allowFiltering: true
        },
        {
          dataField: 'temp_start',
          caption: t('start_control_temperature'),
          alignment: "start"

        },
        {
          dataField: 'temp_end',
          caption: t('end_control_temperature'),
          alignment: "start"
        },
        {
          dataField: 'status_name',
          caption: t('status'),
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: t('edit_by'),
        }
      ],
      exportExcel: {
        fileName: t('job_type_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('job_type_code'), value: 'job_type_code' },
          { label: t('job_type_name'), value: 'job_type_name' },
          { label: t('start_control_temperature'), value: 'temp_start' },
          { label: t('end_control_temperature'), value: 'temp_end' },
          { label: t('status'), value: 'XXXstatus_nameX' },
          { label: t('edit_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      job_type_code: "",
      job_type_name: "",
      temp_start: "",
      temp_end: "",
      status: "Y"
    }}
    modalConfig={{
      visible: true,
      title: t('job_type_information'),
      required: ["job_type_name"],
      fieldTypeNumber: [],
      paramName: "job_type_id",
      apiPath: {
        "get": '',
        "post": 'job_type/add',
        "put": 'job_type/update'
      },
      elements: [
        {
          fieldName: "job_type_code",
          label: t('job_type_code'),
          placeholder: t('job_type_code'),
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "job_type_name",
          label: t('job_type_name'),
          placeholder: t('job_type_name'),
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "temp_start",
          label: t('start_control_temperature'),
          placeholder: t('start_control_temperature'),
          inputType: "number",
          isOneRow: true
        },
        {
          fieldName: "temp_end",
          label: t('end_control_temperature'),
          placeholder: t('end_control_temperature'),
          inputType: "number",
          isOneRow: true
        },
        {
          showSearch: false,
          fieldName: "status",
          label: t('status'),
          inputType: "select",
          defaultValue: "Y",
          options: optionStatus
        }
      ]
    }}
  />
}))

export default JobType